import React from "react";
import AccountGuard from "guards/AccountGuard";
import ConnectPage from "pages/ConnectPage";
import { sentryDsn, environment } from "./config";
import Background from "components/Background";
import Layout from "components/Layout";
import ConnectedPage from "pages/ConnectedPage";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ComposedConnectedProviders from "providers/ComposedConnectedProviders";
import ComposedGlobalProviders from "providers/ComposedGlobalProviders";

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.5,
    environment: environment,
    maxValueLength: 1000,
  });
}

const App: React.FC = () => (
  <ComposedGlobalProviders>
    <Background />

    <AccountGuard
      yeyElement={
        <ComposedConnectedProviders>
          <ConnectedPage />
        </ComposedConnectedProviders>
      }
      neyElement={
        <Layout>
          <ConnectPage />
        </Layout>
      }
    />
  </ComposedGlobalProviders>
);

export default App;
